// The Incoterms as /api/deal-vocabulary serves them (trex/deals/incoterms.py): each term with
// the label of its named place and what it says. Pure, over the vocabulary useDealVocabulary
// reads.

// The named place's label when the deal has no Incoterm, or before the vocabulary has arrived.
export const NAMED_PLACE = 'Named place';

export const incotermOf = (vocabulary, code) =>
  vocabulary.incoterms.find((term) => term.code === code) ?? null;

// The named place is labelled by the Incoterm: a port of shipment under FOB, a place of
// destination under DAP.
export const namedPlaceLabel = (vocabulary, code) =>
  incotermOf(vocabulary, code)?.named_place ?? NAMED_PLACE;
